import styles from "./tasklist.module.css";
import Helmet from "react-helmet";
import Footer from "../../components/Footer";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Slide, Snackbar, TablePagination, Typography } from "@mui/material";
import { ArrowLeft, Home, X } from "react-feather";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import Loader from "../../components/Loader";
import TaskFilter from "./components/TaskFilter";
import TaskCard from "./components/TaskCard";
import { useEffect, useState } from "react";
import AddTaskForm from "./components/AddTaskForm";
import EditTaskForm from "./components/EditTaskForm";
import TaskDetails from "./components/TaskDetails";
import { TableLoaderSmall } from "../../components/LoaderC";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { AddLogCallAPI } from "../../components/AddLogs";

const TaskList = () => {
  const { getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [addTaskModalOpen, setAddTaskModalOpen] = useState(false);
  const [deleteTaskModalOpen, setDeleteTaskModalOpen] = useState(false);
  const [archiveTaskModalOpen, setArchiveTaskModalOpen] = useState(false);
  const [isArchive, setIsArchive] = useState(false);
  const [editTaskModalOpen, setEditTaskModalOpen] = useState(false);
  const [detailsTaskModalOpen, setDetailsTaskModalOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [allTaskList, setAllTaskList] = useState([]);
  const [taskList, setTaskList] = useState([]);
  const [filterData, setFilterData] = useState({ searchKey: "" });
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(8);
  const [selectedId, setSelectedId] = useState(0);
  const [copyTaskModalOpen, setCopyTaskModalOpen] = useState(false);

  useEffect(() => {
    const getTaskList = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      axios(process.env.REACT_APP_CASE_API_URL + "v1/tasks", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((response) => {
        setContentLoading(false);
        setAllTaskList(response.data.data);
      }).catch(() => {
        setContentLoading(false);
      });
    };

    getTaskList();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    if (allTaskList.length > 0) {
      let allTaskListtemp = allTaskList;

      if (filterData.searchKey !== "") {
        let inputVal = filterData.searchKey;
        inputVal = inputVal.toLowerCase();
        allTaskListtemp = allTaskListtemp.filter((item) => {
          return (item.title.toLowerCase().includes(inputVal) || item.property_name.toLowerCase().includes(inputVal) || item.technician_name.toLowerCase().includes(inputVal));
        });
      }

      setTaskList(allTaskListtemp);
    } else {
      setTaskList([]);
    }
  }, [allTaskList, filterData]);

  const addTask = (data) => {
    setAllTaskList((prev) => {
      return [data].concat(prev);
    });
  };

  const editTask = (data) => {
    setAllTaskList((prev) => {
      return prev?.map((i) => {
        if (i?.id === data?.id) return data;
        return i;
      });
    });
  };

  const deleteConfirm = async () => {
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    setDeleteTaskModalOpen(false);
    setLoading(true);

    axios.delete(process.env.REACT_APP_CASE_API_URL + "v1/tasks/" + selectedId, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      setLoading(false);

      setSnackbarMsg(response.data.message);
      setSnackbarOpen(true);

      setAllTaskList((prev) => {
        return prev?.filter((i) => i?.id !== selectedId);
      });

      setSelectedId(0);

      let logData = {
        title: "Task list has been deleted",
        description: [
          "Name: " + response?.data?.data?.title,
          "Property: " + response?.data?.data?.property_name,
          "Technician: " + response?.data?.data?.technician_name,
        ],
      };
      AddLogCallAPI(logData, token);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  };

  const copyConfirm = async () => {
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    setCopyTaskModalOpen(false);
    setLoading(true);

    return axios.get(process.env.REACT_APP_CASE_API_URL + "v1/tasks/copy/" + selectedId, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      setLoading(false);

      setSnackbarMsg(response.data.message);
      setSnackbarOpen(true);

      setAllTaskList((prev) => {
        return [response?.data?.data].concat(prev);
      });

      setSelectedId(0);

      let logData = {
        title: "Task has been copied",
        description: [
          "Name: " + response?.data?.data?.title,
          "Property: " + response?.data?.data?.property_name,
          "Technician: " + response?.data?.data?.technician_name,
        ],
      };
      AddLogCallAPI(logData, token);
      setPage(0);
    })
      .catch((error) => {
        if (typeof error.response !== "undefined")
          toast.error(error.response.data.message);
        setLoading(false);
      });
  };

  const statusChangeConfirm = async () => {
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    setArchiveTaskModalOpen(false);
    setLoading(true);

    let data = { is_archived: 0 };
    if (isArchive) {
      data = { is_archived: 1 };
    }

    axios.put(process.env.REACT_APP_CASE_API_URL + "v1/tasks/" + selectedId, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);

      setSnackbarMsg(response.data.message);
      setSnackbarOpen(true);

      setAllTaskList((prev) => {
        return prev?.map((i) => {
          if (i?.id === selectedId) return { ...i, ...data };
          return i;
        });
      });

      setSelectedId(0);

      let logData = {
        title: isArchive ? "Task list has been disabled" : "Task list has been enabled",
        description: [
          "Name: " + response?.data?.data?.title,
          "Property: " + response?.data?.data?.property_name,
          "Technician: " + response?.data?.data?.technician_name,
        ],
      };
      AddLogCallAPI(logData, token);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  };

  return (<>
    {loading && <Loader />}
    <Helmet title="Task Lists" />

    <div className={`${styles.pageTitleWrap}`}>
      <Typography display="inline" className={`${styles.pageTitle}`}>Task Lists</Typography>
      <nav aria-label="breadcrumb">
        <ol className={`${styles.breadcrumb}`}>
          <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Requests</li>
          <li className={`${styles.breadcrumbItem} ${styles.active}`}>Tasks</li>
        </ol>
      </nav>
    </div>

    <div className={`${styles.BodyCon}`}>
      <div className={`${styles.mainCardDiv}`}>
        <div className={`${styles.mainCard}`}>
          {contentLoading && (<div className="Loader TableLoader">
            <TableLoaderSmall />
          </div>)}

          {!contentLoading && (<div className="control-pane">
            <div className={`${styles.Row}`}>
              <TaskFilter setAddTaskModalOpen={setAddTaskModalOpen.bind(this)} setFilterData={setFilterData} />

              <div className={`${styles.NotesRow}`}>
                {taskList.map((item, index) => {
                  return perPage === -1 || (index >= page * perPage && index < page * perPage + perPage) ? (<TaskCard item={item} setDeleteTaskModalOpen={setDeleteTaskModalOpen.bind(this)} setArchiveTaskModalOpen={setArchiveTaskModalOpen.bind(this)} setIsArchive={setIsArchive.bind(this)} setEditTaskModalOpen={setEditTaskModalOpen.bind(this)} setDetailsTaskModalOpen={setDetailsTaskModalOpen.bind(this)} setSelectedId={setSelectedId.bind(this)} setCopyTaskModalOpen={setCopyTaskModalOpen.bind(this)} />) : null;
                })}

                {taskList.length > 0 && (<div className="Pagination TablePaginationNew List">
                  <TablePagination
                    count={taskList.length}
                    color="primary"
                    page={page}
                    rowsPerPage={perPage}
                    onPageChange={(e, v) => setPage(v)}
                    rowsPerPageOptions={[
                      { label: "4", value: 4 },
                      { label: "8", value: 8 },
                      { label: "16", value: 16 },
                      { label: "All", value: -1 },
                    ]}
                    onRowsPerPageChange={(e) => {
                      setPage(0);
                      setPerPage(e.target.value);
                    }}
                    labelRowsPerPage={"Tasks Per Page:"}
                  />
                </div>)}

                {!contentLoading && taskList.length === 0 && (<div className={`${styles.NoDataMain}`}>
                  <div className={`${styles.NoDataIMG}`}>
                    <img src="/static/img/nodata.svg" alt="No Data" />
                  </div>
                  <p className={`${styles.NoDataText}`}>No Tasks Found</p>
                </div>)}
              </div>
            </div>
          </div>)}
        </div>
      </div>
    </div>

    <div className={detailsTaskModalOpen ? `${styles.ProspectDetailsPanel} ${styles.Open}` : `${styles.ProspectDetailsPanel}`}>
      <div className={`${styles.PanelUnder}`}>
        {detailsTaskModalOpen && (<TaskDetails setDetailsTaskModalOpen={setDetailsTaskModalOpen.bind(this)} selectedId={selectedId} setLoading={setLoading.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} />)}
      </div>
    </div>

    <Dialog
      open={editTaskModalOpen}
      fullWidth
      maxWidth="md"
      onClose={(e) => setEditTaskModalOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp MobileForm Checklist"
    >
      <DialogTitle id="alert-dialog-title">
        <button className={`${styles.BackAddBU}`} onClick={(e) => setEditTaskModalOpen(false)}><ArrowLeft /></button>
        <span>Edit Task List</span>
        <button onClick={(e) => setEditTaskModalOpen(false)}><X /></button>
      </DialogTitle>
      <DialogContent>
        <EditTaskForm setEditTaskModalOpen={setEditTaskModalOpen.bind(this)} selectedId={selectedId} setLoading={setLoading.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} editTaskLocal={editTask.bind(this)} />
      </DialogContent>
    </Dialog>

    <Dialog
      open={addTaskModalOpen}
      fullWidth
      maxWidth="md"
      onClose={(e) => setAddTaskModalOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp MobileForm Checklist"
    >
      <DialogTitle id="alert-dialog-title">
        <button className={`${styles.BackAddBU}`} onClick={(e) => setAddTaskModalOpen(false)}><ArrowLeft /></button>
        <span>Add Task List</span>
        <button onClick={(e) => setAddTaskModalOpen(false)}><X /></button>
      </DialogTitle>
      <DialogContent>
        <AddTaskForm setAddTaskModalOpen={setAddTaskModalOpen.bind(this)} setLoading={setLoading.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMsg={setSnackbarMsg.bind(this)} addTaskLocal={addTask.bind(this)} />
      </DialogContent>
    </Dialog>

    <Dialog
      open={deleteTaskModalOpen}
      onClose={(e) => setDeleteTaskModalOpen(false)}
      fullWidth
      maxWidth="sm"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">
        Would you like to delete this task list?
        <button onClick={(e) => setDeleteTaskModalOpen(false)}><X /></button>
      </DialogTitle>
      <DialogContent>
        <div className="ModalFormGroup">
          <label className="PopupBodyText">The task list information will be removed immediately. You can't undo this action.</label>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={(e) => deleteConfirm(false)} className="CancelPopupBU">Delete</Button>
        <Button onClick={(e) => setDeleteTaskModalOpen(false)} className="SubmitPopupBU">Cancel</Button>
      </DialogActions>
    </Dialog>

    <Dialog
      open={archiveTaskModalOpen}
      onClose={(e) => setArchiveTaskModalOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle id="alert-dialog-title">
        Are you sure you want to {isArchive ? "disable" : "enable"} task list?
        <button onClick={(e) => setArchiveTaskModalOpen(false)}><X /></button>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div className="ModalFormGroup">
            <label className="PopupBodyText">The task will be {isArchive ? "disabled" : "enabled"}{" "}immediately. You can {isArchive ? "enable" : "disable"} it at
              any time.</label>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <button onClick={(e) => setArchiveTaskModalOpen(false)} className="CancelPopupBU">Cancel</button>
        <button onClick={(e) => statusChangeConfirm(false)} className="SubmitPopupBU">Submit</button>
      </DialogActions>
    </Dialog>

    <Dialog
      open={copyTaskModalOpen}
      fullWidth
      maxWidth="xs"
      onClose={(e) => setCopyTaskModalOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">
        Copy Task List
        <button onClick={(e) => setCopyTaskModalOpen(false)}><X /></button>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div className="ModalFormGroup">
            <label className="PopupBodyText">Are you sure you want to copy this task list?</label>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <button onClick={(e) => setCopyTaskModalOpen(false)} className="CancelPopupBU">Cancel</button>
        <button onClick={(e) => copyConfirm()} className="SubmitPopupBU">Copy</button>
      </DialogActions>
    </Dialog>

    <Snackbar
      open={snackbarOpen}
      onClose={(e) => setSnackbarOpen(false)}
      TransitionComponent={Slide}
      message={snackbarMsg}
      autoHideDuration={10000}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      action={
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={(e) => setSnackbarOpen(false)}
        >
          <X />
        </IconButton>
      }
    />

    <Footer />
  </>);
};

export default withAuthenticationRequired(TaskList, {
  onRedirecting: () => <Loader />,
});